import { LabelFilled } from '@doist/icons/product-ui';
import { Stack } from '@doist/marketist';
import { ProductUIAppWindow } from 'components/product-ui/product-ui-app-window/product-ui-app-window';
import { ProductUITaskAttributePill } from 'components/product-ui/product-ui-task-attribute-pill/product-ui-task-attribute-pill';
import { QuickAdd, QuickAddAttributeContainer } from 'components/product-ui/quick-add/quick-add';
import { useTranslation } from 'next-i18next';
import { ProductUIButton } from '../product-ui-button/product-ui-button';
import { ProductUIContextMenu } from '../product-ui-context-menu/product-ui-context-menu';
import { ProductUICursorContainer } from '../product-ui-cursor/product-ui-cursor';
import { ProductUIBasicListItem } from '../product-ui-list-item';
import { ProductUISceneContainer, ProductUISceneLayer } from '../product-ui-scene-container/product-ui-scene-container';
import { TemplateSidebarStandard } from '../product-ui-sidebar/product-ui-sidebar-templates';
import { ProductUITypingIndicator } from '../product-ui-typing-indicator/product-ui-typing-indicator';
import { TemplateTodayView } from '../product-ui-view/product-ui-view-templates';
function LabelsScene() {
  const {
    t
  } = useTranslation('productui');
  return <ProductUISceneContainer backgroundVariant="wave-one" data-sentry-element="ProductUISceneContainer" data-sentry-component="LabelsScene" data-sentry-source-file="labels.tsx">
            <ProductUISceneLayer position="modalOpenLeft" data-sentry-element="ProductUISceneLayer" data-sentry-source-file="labels.tsx">
                <ProductUIAppWindow sidebar={<TemplateSidebarStandard />} view={<TemplateTodayView />} inlineSize={808} blockSize="calc(100% + 7px)" showOverlay data-sentry-element="ProductUIAppWindow" data-sentry-source-file="labels.tsx" />
            </ProductUISceneLayer>
            <ProductUISceneLayer position="center" data-sentry-element="ProductUISceneLayer" data-sentry-source-file="labels.tsx">
                <QuickAdd taskSection={<QuickAdd.TaskText contextMenu={<ContextMenu />}>
                            <QuickAdd.Intent>
                                {t('sequence.labels.proposal')}
                                <ProductUITypingIndicator />
                            </QuickAdd.Intent>
                        </QuickAdd.TaskText>} attributeSection={<QuickAddAttributeContainer>
                            <ProductUITaskAttributePill variant="labelPlaceholder" />
                        </QuickAddAttributeContainer>} footerSection={<QuickAdd.FooterContainer>
                            <QuickAdd.FooterProjectButton />
                            <QuickAdd.FooterSpacer />
                            <ProductUIButton className="addTaskButton" variant="primary">
                                {t('quickAdd.addTask')}
                            </ProductUIButton>
                        </QuickAdd.FooterContainer>} data-sentry-element="QuickAdd" data-sentry-source-file="labels.tsx" />
            </ProductUISceneLayer>
        </ProductUISceneContainer>;
}
function ContextMenu() {
  const {
    t
  } = useTranslation('productui');
  return <ProductUIContextMenu placement={{
    top: 34,
    right: -100
  }} width={200} data-sentry-element="ProductUIContextMenu" data-sentry-component="ContextMenu" data-sentry-source-file="labels.tsx">
            <Stack gap="2" data-sentry-element="Stack" data-sentry-source-file="labels.tsx">
                <ProductUICursorContainer size="lg" data-sentry-element="ProductUICursorContainer" data-sentry-source-file="labels.tsx">
                    <ProductUIBasicListItem icon={LabelFilled} iconColor="orange" label={t('sequence.labels.email')} hovered={true} data-sentry-element="ProductUIBasicListItem" data-sentry-source-file="labels.tsx" />
                </ProductUICursorContainer>
                <ProductUIBasicListItem icon={LabelFilled} iconColor="purple" label={t('sequence.labels.deepWork')} data-sentry-element="ProductUIBasicListItem" data-sentry-source-file="labels.tsx" />
                <ProductUIBasicListItem icon={LabelFilled} iconColor="lavender" label={t('sequence.labels.home')} data-sentry-element="ProductUIBasicListItem" data-sentry-source-file="labels.tsx" />
                <ProductUIBasicListItem icon={LabelFilled} iconColor="grey" label={t('sequence.labels.waiting')} data-sentry-element="ProductUIBasicListItem" data-sentry-source-file="labels.tsx" />
            </Stack>
        </ProductUIContextMenu>;
}
export { LabelsScene };